define(function (require) {

    window.lpTag = window.lpTag || {};
    window.lpTag.WebAgent = window.lpTag.WebAgent || {};

    var App = window.App || {};
    var QueueOrbView = require('web-agent-js-views/QueueOrbView');
    var OfflineOrbViewController = require('web-agent-viewControllers/OfflineOrbViewController');
    var EngagementOrbsAreaViewController = require('web-agent-viewControllers/EngagementOrbsAreaViewController');
    var TabsManagerViewController = require('web-agent-viewControllers/TabsManagerViewController');

    var ViewController = require('web-agent-framework/ViewController');
    var agentLEManager = require('web-agent-utils/agentLEManager');

    var FooterViewController = ViewController.extend({

        ControllerName: "FooterViewController",

        LPViewMap: {
            offlineOrb: ".lpview_offline_orb",
            queueOrb: ".lpview_queue_orb",
            engagementOrbsArea: ".lpview_engagement_orbs_area",
            dividers: ".lpview_divider",
            footer: ".lpview_footer",
            visitorListToggle: ".lpview_visitor_toggle"
        },

        initialize: function () {
            this.registerChannelEvents();
        },
        events: function () {
            this.bindModel({modelPath : "agent.status", callback : this.statusChanged});
            this.bindViewEvent({selector: this.LPViewMap.visitorListToggle, appName : TabsManagerViewController.applicationType, DOMEvent : "click", UIEvent : this.eventType.VISITOR_FOCUSED});
        },
        render: function () {
        }
    });

    FooterViewController.prototype.createEngagmentArea = function () {
        if (!this.engagementOrbsArea) {
            this.engagementOrbsArea = new EngagementOrbsAreaViewController({
                modelController: this.modelController,
                templateFile: 'LP_engagement_orbs_area.html'
            });
            this.addViewController({viewController : this.engagementOrbsArea, target : this.LPViewMap.engagementOrbsArea});
        }
    };

    FooterViewController.prototype.createQueueOrb = function () {
        if (!this.queueOrb) {
            this.queueOrb = new QueueOrbView({
                modelController: lpTag.WebAgent.queueOrbController,
                templateFile: 'LP_queue_orb.html'
            });
            this.addViewController({viewController : this.queueOrb, target : this.LPViewMap.queueOrb});
        }
    };

    FooterViewController.prototype.createOfflineOrb = function () {
        if (!this.offlineOrb) {
            this.offlineOrb = new OfflineOrbViewController({
                modelController: this.modelController,
                templateFile: 'LP_Offline_Orb.html'
            });
            this.addViewController({viewController : this.offlineOrb, target : this.LPViewMap.offlineOrb});
        }
    };

    FooterViewController.prototype.statusChanged = function (data) {
        var listToggle = this.getFirstElement(this.LPViewMap.visitorListToggle);
        var shortcutType = this.shortcutType.LIST_VIEW;

        if (data.newValue === 'loggedIn') {
            this.lpShow(listToggle);
            this.createQueueOrb();
            this.createOfflineOrb();
            this.createEngagmentArea();
            this.lpShow(this.LPViewMap.footer); //todo: Recreate the footer on login, no need to hide and show
            this.showDividers();
            this.registerShortcut(shortcutType, this.fireFocusTables, {position: "top"});
        } else {
            if (this.queueOrb) {
                this.queueOrb = null;
            }
            if (this.offlineOrb) {
                this.offlineOrb = null;
            }
            if (this.engagementOrbsArea) {
                this.engagementOrbsArea = null;
            }
            this.hideDividers();
            this.lpHide(listToggle);
            this.unregisterShortcut(shortcutType, this.fireFocusTables);
        }
        listToggle = null;
    };

    FooterViewController.prototype.showDividers = function () {
        var dividers = this.getElements(this.LPViewMap.dividers);
        for (var index = 0; index < dividers.length; index++) {
            this.lpShow(dividers[index]);
        }
        dividers = null;
    };

    FooterViewController.prototype.hideDividers = function () {
        var dividers = this.getElements(this.LPViewMap.dividers);
        for (var index = 0; index < dividers.length; index++) {
            this.lpHide(dividers[index]);
        }
        dividers = null;
    };

    FooterViewController.prototype.fireFocusTables = function () {
        this.viewEventsHandler.fireEvent({appName : TabsManagerViewController.applicationType, UIEvent : this.eventType.VISITOR_FOCUSED});
    };

    FooterViewController.prototype.registerChannelEvents = function () {
        var webAgentChannel = agentLEManager.channelLE();
        var webAgentMediaCodes = agentLEManager.getLEMediaCodesWebAgent();
        webAgentChannel.comply(webAgentMediaCodes.commands.navigateToVisitorTables, this.fireFocusTables.bind(this));
    };

    return FooterViewController;

});
